const userQuestionAnswerSheet = {
    getall: 'UserQuestionAnswerSheet/getall',
    update: 'UserQuestionAnswerSheet/update',
}
export default userQuestionAnswerSheet